import Layout from "@/components/layout/Layout";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { 
  Calculator, 
  ListTodo, 
  FileText, 
  Users, 
  Handshake, 
  Settings, 
  PieChart 
} from "lucide-react";
import { motion } from "framer-motion";

const SolarDashboard = () => {
  const cardItems = [
    {
      id: 'calculadora',
      title: 'Calculadora Solar',
      description: 'Simule instalações',
      icon: <Calculator className="h-5 w-5 text-amber-500" />,
      path: '/solar/calculadora',
      color: 'bg-amber-50 text-amber-700 border-amber-200',
      hoverColor: 'hover:bg-amber-100'
    },
    {
      id: 'fluxo',
      title: 'Fluxo Projetos',
      description: 'Kanban e projetos',
      icon: <ListTodo className="h-5 w-5 text-blue-500" />,
      path: '/solar/fluxo',
      color: 'bg-blue-50 text-blue-700 border-blue-200',
      hoverColor: 'hover:bg-blue-100'
    },
    {
      id: 'propostas',
      title: 'Propostas',
      description: 'Gerenciar propostas',
      icon: <FileText className="h-5 w-5 text-purple-500" />,
      path: '/solar/propostas',
      color: 'bg-purple-50 text-purple-700 border-purple-200',
      hoverColor: 'hover:bg-purple-100'
    },
    {
      id: 'clientes',
      title: 'Clientes',
      description: 'Gerenciar clientes',
      icon: <Users className="h-5 w-5 text-green-500" />,
      path: '/clientes',
      color: 'bg-green-50 text-green-700 border-green-200',
      hoverColor: 'hover:bg-green-100'
    },
    {
      id: 'parceiros',
      title: 'Parceiros',
      description: 'Gerenciar parceiros',
      icon: <Handshake className="h-5 w-5 text-teal-500" />,
      path: '/parceiros',
      color: 'bg-teal-50 text-teal-700 border-teal-200',
      hoverColor: 'hover:bg-teal-100'
    },
    {
      id: 'configuracoes',
      title: 'Configurações',
      description: 'Personalizar sistema',
      icon: <Settings className="h-5 w-5 text-gray-500" />,
      path: '/solar/configuracao/sistemas',
      color: 'bg-gray-50 text-gray-700 border-gray-200',
      hoverColor: 'hover:bg-gray-100'
    },
    {
      id: 'relatorios',
      title: 'Relatórios',
      description: 'Análises e estatísticas',
      icon: <PieChart className="h-5 w-5 text-indigo-500" />,
      path: '/relatorios',
      color: 'bg-indigo-50 text-indigo-700 border-indigo-200',
      hoverColor: 'hover:bg-indigo-100'
    }
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3
      }
    }
  };

  const item = {
    hidden: { y: 20, opacity: 0 },
    show: { 
      y: 0, 
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 260,
        damping: 20
      }
    }
  };

  return (
    <Layout>
      <div className="container mx-auto px-4 py-8 max-w-7xl">
        <motion.div 
          className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4"
          variants={container}
          initial="hidden"
          animate="show"
        >
          {cardItems.map((cardItem) => (
            <motion.div key={cardItem.id} variants={item}>
              <Link to={cardItem.path} className="block h-full">
                <Card className={`h-full overflow-hidden transition-all duration-300 ${cardItem.color} ${cardItem.hoverColor} hover:shadow-md transform hover:-translate-y-1`}>
                  <CardContent className="flex flex-col items-center text-center p-4">
                    <div className="p-2 rounded-full bg-white mb-2 shadow-sm">
                      {cardItem.icon}
                    </div>
                    <h3 className="font-medium text-base">{cardItem.title}</h3>
                    <p className="text-xs opacity-75 mt-1">{cardItem.description}</p>
                  </CardContent>
                </Card>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </Layout>
  );
};

export default SolarDashboard;
